import React from "react";
import FormWrapper from '../../../library/form/components/FormWrapper';
import FormROValue from '../../../library/form/components/FormROValue1';
import FormButton from '../../../library/form/components/FormActionButton2';
import FormLink from '../../../library/form/components/FormLink'

const InvExpItemRow = (props) => {
    const { formObject, rowKey } = props;

    return (
        <div className="phViewAreaItem uiBoxItem phViewContent">
            <div className="phViewRef" style={{display:"none"}}>
                <FormWrapper customWrapper="div" wrapperClass="uiInline" formObject={formObject} rowKey={rowKey} action={{ paramName: "refContainer" }} >
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "refType" }} />

                    <FormLink formObject={formObject} rowKey={rowKey} className="uiLink"
                        action={{
                            paramName: "refId",
                            actionId: "show",  actionName: "invcomp",
                            containerKey: "popup"
                        }}
                        linkProp={{ target: "_blank" }}
                    ></FormLink>
                </FormWrapper>
            </div>
            <div className="phViewName">
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "lineNo" }} className="uiBoxItemLineNo" />

                <FormLink formObject={formObject} rowKey={rowKey} className="uiLink"
                    action={{
                        paramName: "itemId",
                        actionId: "show",  actionName: "invcomp",
                        containerKey: "popup"
                    }}
                    linkProp={{ target: "_blank" }}
                ></FormLink>

                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "itemName" }} />
            </div>
            <div className="phViewInfo">
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "itemDesc" }} />
            </div>
            <div className="phViewCost">
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "claimAmount" }} />
            </div>
            <div className="phViewAction uiActionBlock">
                <FormButton formObject={formObject} rowKey={rowKey}
                    starIcon="edit"
                    onlyIcon={true}
                    tooltip="Edit"
                    starIconClassName="uiColorNeutralAction"
                    action={{ actionId: "edit", paramName: "editBtn", actionParam: {}, containerKey: "popup" }}
                    className="" ></FormButton>

                <FormButton formObject={formObject} rowKey={rowKey}
                    starIcon="clear"
                    onlyIcon={true}
                    tooltip="Delete"
                    starIconClassName="uiColorNegativeAction"
                    action={{ actionId: "del", paramName: "delBtn",  actionParam: {}, containerKey: "row" }}
                    className="" ></FormButton>
            </div>
        </div>
    )
}

export default InvExpItemRow